import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import { Button, Container, Grid, Header, Responsive } from 'semantic-ui-react'

import '../styles/semantic.css'
import '../styles/site.scss'
import './index.scss'

const IndexPage = ({ data }) => (
  <Grid columns={1}>
    <Grid.Row>
      <Grid.Column>
        <Container text textAlign='center'>
          <Img sizes={data.imageFeaturedShirt.childImageSharp.sizes} />
        </Container>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row style={{ marginBottom: '1rem' }}>
      <Grid.Column>
        <Container text textAlign='center'>
          <Header size='huge' className='fancy' textAlign='center'>Dress minimal. Do more.</Header>
        </Container>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row color='yellow'>
      <Grid.Column style={{ margin: '1rem' }}>
        <Container text textAlign='left' style={{ color: 'black', marginTop: '1rem', marginBottom: '1rem' }}>
          We believe in simplifying your life. We want to
          help you spend less time deciding what to wear,
          and more time on what's important to you.
        </Container>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column style={{ margin: '2rem' }}>
        <Container text textAlign='center'>
          <Grid columns={1} centered>
            <Grid.Column mobile={16} tablet={12} computer={10}>
              <Img sizes={data.imageCoFounderHeadshots.childImageSharp.sizes} />
            </Grid.Column>
          </Grid>
        </Container>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column style={{ margin: '1rem' }}>
        <Container text textAlign='left'>
          Closet Minimal is a group of troublemakers in PDX
          who share a vision of keeping your closet stocked
          with your basic outfit—your uniform—made with
          quality materials and craftsmanship.
        </Container>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <Container text textAlign='center'>
          <Responsive maxWidth={-1}><Button color='yellow' style={{ width: '10rem', height: '3rem' }}>Read Our Blog</Button></Responsive>
          <Link to='/contact/'><Button color='yellow' style={{ width: '10rem', height: '3rem' }} >Keep in Touch</Button></Link>
        </Container>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

export const IndexPageQueries = graphql`
  query IndexPageQueries {
    imageFeaturedShirt: file(relativePath: { eq: "featured_shirt.png"}) {
      childImageSharp {
        sizes(maxWidth: 700) {
          ...GatsbyImageSharpSizes_tracedSVG
        }
      }
    }
    imageCoFounderHeadshots: file(relativePath: { eq: "cofounder_headshots.png"}) {
      childImageSharp {
        sizes(maxWidth: 425) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js